<template>
  <div class="confirm-warp">
    <div v-if="!isCyberPayVisible">Loading</div>
    <template v-if="isCyberPayVisible">
      <iframe
        id="cardinal_collection_iframe"
        name="collectionIframe"
        height="600"
        width="100%"
        ref="iframe"
        @load="onIframeLoad"
      ></iframe>
    </template>
    <template v-if="!isCyberPayVisible">
      <iframe
        id="cardinal_collection_iframe"
        name="collectionIframe"
        height="10"
        width="10"
        style="display:none;"
      ></iframe>
    </template>
    <form
      id="cardinal_collection_form"
      method="POST"
      target="collectionIframe"
      :action="collectionUrl"
    >
      <input type="hidden" name="JWT" :value="accessToken" />
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CyberSourceMixin from "../../mixins/CyberSource";

export default {
  name: "CyberPayment",
  mixins: [CyberSourceMixin],
  components: {},
  computed: {
    ...mapState(["system", "browser"]),
    i18n() {
      return this.$t("confirm");
    }
  },
  data() {
    return {
      isCyberPayVisible: false,
      accessToken: "",
      collectionUrl: ""
    };
  },
  watch: {
    "$route.query.type"(val, oldVal) {
      if (val === "formVisibleHtml") {
        this.initData();
      }
    }
  },
  methods: {
    initData() {
      const { type, accessToken, collectionUrl } = this.$route.query;
      if (accessToken && collectionUrl) {
        this.accessToken = accessToken;
        this.collectionUrl = collectionUrl;
        this.isCyberPayVisible = type === "formVisibleHtml";
        setTimeout(() => {
          document.querySelector("#cardinal_collection_form").submit();
        }, 300);
        const onMessage = event => {
          this.onListenerMessage(event);
        };
        // Listen for completion
        window.addEventListener("message", onMessage, false);
      }
    },
    // 监听message事件的回调函数
    onListenerMessage(event) {
      const origin = new URL(this.collectionUrl).origin;
      if (event.origin === origin) {
        if (!this.isCyberPayVisible) {
          if (this.Query && this.Query.referenceId) {
            const { CyberPayInfo = {} } = this.$store.state;
            const payInfo = CyberPayInfo[this.Query.referenceId];
            if (payInfo) return this.multicurrencyCheckEnrollment(payInfo);
          }
          this.$router.push(`/result?payMode=CyberPay`);
          window.removeEventListener("message", function() {}, false);
        }
      }
    },
    onIframeLoad(evt) {
      const cyberWin = this.$refs.iframe.contentWindow;
      const _result = `${process.env.VUE_APP_DOMAIN}/#/result`;
      const _herf = cyberWin.location.href;
      console.info(`🚀 ~ _result:${_herf.includes(_result)}-_herf:${_herf}`);
      if (_herf.includes(_result)) {
        location.href = _herf;
        window.removeEventListener("message", function() {}, false);
      }
    }
  },
  mounted() {
    this.Query = this.$route.query;
    this.initData();
  },
  created() {}
};
</script>

<style lang="less" scoped>
.confirm-warp {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}
</style>
